import { Component, Input, OnInit, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { ChildNotesService } from '../../child-notes/child-notes.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ExportJsonService } from 'src/app/_services/export-json.service';
@Component({
	selector: 'download-notes-button',
	templateUrl: './download-notes-button.component.html',
	styleUrls: ['./download-notes-button.component.css'],
})
export class DownloadNotesButtonComponent implements OnInit {
	subscriptions: Subscription[] = [];

	@Input() id: number;
	@Input() text: string = 'Download';
	@Input() type: string = 'node';

	loading = false;
	totalNotes = 0;
	dropdownOpen = false;

	constructor(
		public childNotesService: ChildNotesService,
		public exportJsonService: ExportJsonService,
		private elementRef: ElementRef
	) {}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.dropdownOpen = false;
		}
	}

	ngOnInit(): void {}

	downloadStudentNote(id: number, formate: string = 'xlsx'): void {
		this.loading = true;
		this.dropdownOpen = false;
		this.subscriptions.push(
			this.childNotesService.downloadStudentNotes(id, this.type).subscribe((data) => {
				switch (formate) {
					case 'csv':
						this.exportJsonService.exportJsonToCsv(data.result, data.filename);
						break;
					case 'xlsx':
						this.exportJsonService.exportJsonToExcel(data.result, data.filename);
						break;
				}
				this.loading = false;
			})
		);
	}

	ngOnChanges(changes: SimpleChanges) {
		this.id = changes.id.currentValue;
		if (this.id) {
			this.subscriptions.push(
				this.childNotesService.downloadStudentNotes(this.id, this.type).subscribe((data) => {
					if (data.result) {
						let count = data.result;
						this.totalNotes = count.length;
					} else {
						this.totalNotes;
					}
				})
			);
		}
	}
}
